module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sensor":"Sensor"},"de":{"sensor":"Sensor"},"fr":{"sensor":"Sensor"},"it":{"sensor":"Sensor"}}')
  delete Component.options._Ctor
}
